import { render, staticRenderFns } from "./PersonApprovalArea.vue?vue&type=template&id=6960b2a1&scoped=true&"
import script from "./PersonApprovalArea.vue?vue&type=script&lang=js&"
export * from "./PersonApprovalArea.vue?vue&type=script&lang=js&"
import style0 from "./PersonApprovalArea.vue?vue&type=style&index=0&id=6960b2a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6960b2a1",
  null
  
)

export default component.exports